<template>
    <vs-row class="mb-4">
        <vs-col class="w-1/2 lg:w-4/12">
            <label class="vs-radio--label" :class="[isChild?'ml-10':'', data.outNormal?'text-danger':'']"><span v-if="isChild">-</span> {{data.name + (data.outNormal? ' *':'')}}</label>
        </vs-col>
        <vs-col class="w-1/2 lg:w-4/12 text-center flex">
            <div class="centerx default-input w-full">
                <v-select :disabled="!data.enable" class="w-full" :class="data.outNormal?'text-danger':''" v-if="data.measureType.code === 'MULTI'" label="name" :options="data.measureChoice.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="inputVal" />
                <currency-input v-else :disabled="!data.enable" :danger="data.outNormal" placeholder="Result" v-model="inputVal" />
            </div>
            <!---
            <div class="centerx default-input justify-center flex">
                <vs-checkbox :disabled="!data.enable" :color="data.outNormal?'danger':'primary'"/>
            </div>
            -->
        </vs-col>
        <vs-col class="w-1/2 lg:w-2/12 text-center">
            <label class="vs-radio--label" :class="data.outNormal?'text-danger':''">{{data.unit}}</label>
        </vs-col>
        <vs-col class="w-1/2 lg:w-2/12 text-center">
            <label class="vs-radio--label" :class="data.outNormal?'text-danger':''">{{data.measureRanges}}</label>
        </vs-col>
    </vs-row>
</template>

<script>
    import CurrencyInput from "@/components/currency-input";
    import vSelect from 'vue-select';

    export default {
        components: {
            CurrencyInput, 'v-select': vSelect
        },
        props: ['data', 'isChild', 'value'],
        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>
